export enum EnumTipoAutor {
    DEPUTADO_FEDERAL = 1,
    DEPUTADO_ESTADUAL = 2,
    SENADOR = 3,
    BANCADA = 4,
    COMISSAO = 5,
    RELATOR = 6,
}